import {PlainDtoModel} from '../../../../common/entity/dto/plain/plainDto.model';
import {AddressModel} from '../../../../common/entity/address.model';
import {PartnerPersonModel} from '../../../../partner/modules/person/api/entity/partnerPerson.model';
import {WorkflowTaskSummaryModel} from '../../../../workflow/task/api/model/common/workflowTaskSummary.model';
import {PersonModel} from "../../../../person/api/entity/person.model";
import {PersonSummaryModel} from "../../../../person/api/entity/personSummary.model";
import {DocumentSummaryModel} from "../../../../document/common/api/model/documentSummary.model";

export class ReportRecipientModel implements PlainDtoModel {
    selected = false;
    email: string;
    partnerPerson: PartnerPersonModel;
    sendByEmail = false;
    sendByMail = false;
    address: AddressModel;
    id: number;
    emailWorkflowTasks: WorkflowTaskSummaryModel[] = [];
    document: DocumentSummaryModel;
}
